import * as types from "../actions/types";

const initialState = {
    list: [],
    loading: false,
    item: {},
    loadingItem: false,
    courses: [],
    students: [],
    studentsLoading: false
};

export default function groups_do_vd(state = initialState, action) {
    switch (action.type) {
        case types.SET_GROUPS_DO_VD_LIST:
            return {
                ...state,
                list: action.payload
            };
        case types.SET_GROUPS_DO_VD_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case types.SET_GROUPS_DO_VD_ITEM:
            return {
                ...state,
                item: action.payload
            };
        case types.SET_GROUPS_DO_VD_ITEM_LOADING:
            return {
                ...state,
                loadingItem: action.payload
            };
        case types.SET_GROUPS_DO_VD_COURSES:
            return {
                ...state,
                courses: action.payload
            };
        case types.SET_GROUPS_DO_VD_STUDENTS:
            return {
                ...state,
                students: action.payload
            };
        case types.SET_GROUPS_DO_VD_STUDENTS_LOADING:
            return {
                ...state,
                studentsLoading: action.payload
            };
        default:
            return state;
    }
}
